import { Card } from "antd";
import { type ReactNode, useId } from "react";

export interface ChartCardProps {
	/** ⚠️ Tarjima qilingan matn — primitivlar `useTranslation` ga tegmaydi. */
	title: string;
	subtitle?: string;
	extra?: ReactNode;
	children: ReactNode;
	className?: string;
}

/**
 * Diagramma kartasi — sarlavha, izoh, o'ng burchakdagi amal va tarkib.
 *
 * ⚠️ `section` + `aria-labelledby`: ekran o'quvchisi kartani sarlavhasi
 * bilan nomlangan mintaqa sifatida e'lon qiladi. antd `Card` ning o'zi
 * oddiy `div` chizadi.
 *
 * Fon va chegara ranglarini antd tema tokenlari beradi (dark rejim
 * `ConfigProvider` orqali), shuning uchun bu yerda rang YOZILMAYDI.
 */
export function ChartCard({ title, subtitle, extra, children, className }: ChartCardProps) {
	const sarlavhaId = useId();

	return (
		<section aria-labelledby={sarlavhaId} className={className}>
			<Card size="small" className="h-full">
				<div className="mb-3 flex items-start justify-between gap-3">
					<div className="min-w-0">
						<div
							id={sarlavhaId}
							data-chart-title
							className="font-medium text-[13px]"
							style={{ color: "var(--chart-ink)" }}
						>
							{title}
						</div>
						{subtitle ? (
							<div
								data-chart-subtitle
								className="mt-0.5 text-xs"
								style={{ color: "var(--chart-axis)" }}
							>
								{subtitle}
							</div>
						) : null}
					</div>
					{extra ? <div className="shrink-0">{extra}</div> : null}
				</div>
				{children}
			</Card>
		</section>
	);
}
